import React from 'react';
import { Col, Row } from 'react-bootstrap';

import AppLayout from '../../layouts/AppLayout/AppLayout';
import { NioButton, NioCard, NioSection, NioMedia } from '../../components';
import { useTranslation } from '../../i18n/I18nProvider';

function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <AppLayout title={t('pages.notFoundTitle')} rootClass="layout-1">
      <NioSection className="nk-section-error pt-120 pt-xl-180 overflow-hidden pb-0" masks={['blur-1 left top', 'blur-1 right bottom']}>
        <Row className="justify-content-center text-center">
          <Col lg={6} xl={8}>
            <div className="pb-5 pb-lg-7">
              <div className="error-number mb-5">404</div>
              <h2 className="m-0 mb-2 mb-md-4">{t('pages.notFoundHeading')}</h2>
              <p className="fs-20">{t('pages.notFoundBody')}</p>
              <ul className="nk-btn-group pt-4 justify-content-center pt-3 pt-md-5 pb-2">
                <li>
                  <NioButton href="/" className="btn-primary" label={t('pages.goHome')} />
                </li>
                <li>
                  <NioButton href="/" className="btn-outline-primary" label={t('pages.tryAgain')} />
                </li>
              </ul>
              <hr className="mt-md-6" />
            </div>
          </Col>
        </Row>
        <NioSection.Content>
          <Row className="g-gs">
            <Col md={6}>
              <NioCard className="bg-blue-50 border-0 h-100 rounded-2">
                <NioCard.Body className="d-flex flex-column">
                  <NioMedia size="lg" rounded variant="primary" icon="help-fill" className="mb-3 mb-md-5" />
                  <h3>{t('pages.readFaqs')}</h3>
                  <p className="fs-16 mb-0">{t('pages.readFaqsDesc')}</p>
                  <NioButton href="/help-center" className="btn-link text-primary mt-5" icon="arrow-right after" label={t('pages.readFaqsLink')} />
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col md={6}>
              <NioCard className="bg-green-50 border-0 h-100 rounded-2">
                <NioCard.Body className="d-flex flex-column">
                  <NioMedia size="lg" rounded variant="success text-white" icon="account-setting" className="mb-3 mb-md-5" />
                  <h3>{t('pages.helpSupport')}</h3>
                  <p className="fs-16 mb-0">{t('pages.helpSupportDesc')}</p>
                  <NioButton href="/help-center" className="btn-link text-success mt-5" icon="arrow-right after" label={t('pages.helpSupportLink')} />
                </NioCard.Body>
              </NioCard>
            </Col>
          </Row>
        </NioSection.Content>
      </NioSection>
    </AppLayout>
  );
}

export default NotFoundPage;
